/**
 * PersonDropdown Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectProductsArray } from 'services/products/selectors';
import { Product } from 'services/products/types';

// Utils
// @ts-ignore
import orderBy from '../../../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectOrderedData = createDeepEqualSelector(
    selectProductsArray,
    (productsArray) => orderBy(productsArray, 'name')
);

const selectOptions = createDeepEqualSelector(
    selectOrderedData,
    (orderedDataState: Product[]) =>
        orderedDataState.map(({ id, name }) => ({
            key: id,
            text: name,
            value: id
        }))
);

export { selectOptions };
